<template>
  <ScrollingBox
    section-id="developer-type"
    :section-title="sectionTitle"
    :section-subtitle="sectionSubtitle"
    :section-description="sectionDescription"
    :section-items="items"
    :data="developerTypes"
    button-text="Learn more"
    :is-apply-button="false"
    smaller
    button-redirect="how-it-works"
    class="types"
  />
</template>

<script>
import ScrollingBox from '../shared/ScrollingBox/ScrollingBox.vue';

export default {
  components: { ScrollingBox },
  data() {
    return {
      sectionTitle: 'What does it take to become a Proxify member?',
      sectionSubtitle: 'Not just great coders. Great team members.',
      sectionDescription:
        'We assess more than just your code. Our process evaluates both technical ability and the soft skills that make collaboration a success, including communication, reliability, and English proficiency. We look for professionals who can thrive in client teams, not just pass a test.',
      items: [
        {
          title: 'Time investment:',
          description: '4-5 hours',
          tooltip: 'Expect to spend around 4 to 5 hours of your time.',
        },
        {
          title: 'Timeline:',
          description: '3 to 15 days',
          tooltip:
            'The full process typically takes between 3 to 15 days to complete.',
        },
      ],
      developerTypes: [
        {
          illustration: '/images/home-page/developer-type/illustration1.svg',
          title: 'Engineering excellence',
          description:
            'Ability to build scalable applications according to best code practices. proven through a 90-minute test in your specialty.',
        },
        {
          illustration: '/images/home-page/developer-type/illustration2.svg',
          title: 'Velocity',
          description:
            'Can consistently deliver high output, own features, and independently drive projects.',
        },
        {
          illustration: '/images/home-page/developer-type/illustration3.svg',
          title: 'Direction',
          description:
            'The ability to steer the work into a more suitable direction.',
        },
        {
          illustration: '/images/home-page/developer-type/illustration4.svg',
          title: 'Advanced English',
          description:
            'You can communicate clearly and confidently in English, not limited to technical discussions.',
        },
        {
          illustration: '/images/home-page/developer-type/illustration5.svg',
          title: 'Collaboration skills',
          description:
            'You work well with others and bring a collaborative mindset to every team.',
        },
      ],
    };
  },
};
</script>
